import { Injectable } from '@angular/core';
import {
  DwAction,
  DwActionHandler,
  DwActionResult,
  DwActionType,
  DwButtonType,
  DwEventService,
  DwOrmDataService,
  DwMdFormActionState
} from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataItemNames, ProcessorConfigEntity } from '../../../meta-data/app-meta-data.service';
import { PaymentsRepositoryService } from '../services/payments-repository.service';

@DwAction({
  keyName: 'recreate-processor-customer',
  display: 'Recreate Stripe Customer',
  actionType: DwActionType.formAction,
  isGlobal: false,
  parentItemName: [AppMetaDataItemNames.ProcessorConfig],
  actionMessage: 'Creating a new Stripe customer...',
  defaultButtonConfig: {
    useParentDisplay: false,
    buttonText: 'Recreate Stripe Customer',
    buttonType: DwButtonType.standard,
    buttonClass: 'btn btn-warning',
    iconClass: 'fa fa-rotate'
  },
  defaultConfirmConfig: {
    showDialogConfig: true,
    showConfirmDialog: true,
    title: 'Recreate Stripe customer?',
    message: 'This creates a new Stripe customer and deactivates every payment method stored for the current customer. ' +
      'Deactivated payment methods must be added again. Existing invoices will not be reprocessed automatically.'
  }
})
@Injectable()
export class RecreateProcessorCustomerActionService implements DwActionHandler {
  constructor(
    private paymentsRepository: PaymentsRepositoryService,
    private dwEventService: DwEventService
  ) {}

  handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
    const processorConfig = actionState.formApi.getFormData<ProcessorConfigEntity>();

    return this.paymentsRepository.recreateProcessorCustomer(processorConfig.ProcessorConfigId)
      .pipe(map(apiResult => {
        const result: DwActionResult = {
          success: apiResult.Success,
          message: apiResult.Message
        };

        if (apiResult.Success) {
          this.dwEventService.publishEvent(
            DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.PaymentMethod),
            {}
          );
          this.dwEventService.publishEvent(
            DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaDataItemNames.ProcessorConfigCustomerHistory),
            {}
          );
          actionState.formApi.loadData(true).subscribe();
        }

        return result;
      }));
  }
}
